import { ServerActionName } from '@headless-workspace/config';
import { AsyncData, ResultEmpty, ResultFailure } from '@headless-workspace/core-domain';
import { UserRevalidationKey, useSafeSWR } from '../../../../client';
import { getSelectedStoreServerAction, StoreInfoValue } from '../../../../server';

const GET_SELECTED_STORE_DEFAULT_ERROR = 'GET_SELECTED_STORE_ERROR';
const GET_SELECTED_STORE_ERROR_MSG = 'An error occurred while fetching the selected store.';

export const useSelectedStore = (productId: string): AsyncData<StoreInfoValue> => {
    const {
        data: swrData,
        isLoading,
        error,
    } = useSafeSWR([UserRevalidationKey.SelectedStore, productId], ServerActionName.getSelectedStore, () =>
        getSelectedStoreServerAction(productId),
    );

    if (!swrData) {
        if (error) {
            return {
                isLoading,
                result: ResultFailure(
                    GET_SELECTED_STORE_DEFAULT_ERROR,
                    error instanceof Error ? error.message : GET_SELECTED_STORE_ERROR_MSG,
                ),
            };
        }

        return { isLoading, result: ResultEmpty() };
    }

    return { isLoading, result: swrData };
};
